import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "info flex gap-8" }
const _hoisted_2 = { class: "info__block flex p-4 shadow rounded w-1/2" }
const _hoisted_3 = { class: "info__image flex h-full w-full relative overflow-hidden" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "info__block p-4 shadow rounded flex flex-col gap-4 w-1/2" }
const _hoisted_7 = {
  key: 0,
  class: "text-field flex flex-col gap-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "title font-medium" }, " Привет, меня зовут: ", -1)
const _hoisted_9 = { class: "text text-xl" }
const _hoisted_10 = {
  key: 1,
  class: "text-field flex flex-col gap-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "title font-medium" }, " Пол: ", -1)
const _hoisted_12 = { class: "text text-xl" }
const _hoisted_13 = {
  key: 2,
  class: "text-field flex flex-col gap-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "title font-medium" }, " Дата моего рождения: ", -1)
const _hoisted_15 = { class: "text text-xl" }
const _hoisted_16 = {
  key: 3,
  class: "text-field flex flex-col gap-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "title font-medium" }, " Мой почтовый адрес: ", -1)
const _hoisted_18 = { class: "text text-xl" }
const _hoisted_19 = {
  key: 4,
  class: "text-field flex flex-col gap-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "title font-medium" }, " Мой почтовый адрес: ", -1)
const _hoisted_21 = { class: "text text-xl" }

import { onActivated, onBeforeMount, computed } from "vue";
import { useStore } from "vuex";
import { IUserState } from "@/store/user/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeInfo',
  setup(__props) {

const store = useStore();

const getUserData = (): void => {
  store.dispatch("loadUserInfo");
};

onBeforeMount(() => {
  console.log(
    "🚀 ~ file: HomeInfo.vue ~ line 36 ~ onBeforeMount ~ onBeforeMount",
    "onBeforeMount"
  );

  getUserData();
});

const userData = computed((): IUserState => {
  return store.getters.userInfo;
});

const userFullname = computed((): string | null => {
  return (userData.value.username + " " + userData.value.usersurname).trim();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(userData).userphoto)
            ? (_openBlock(), _createElementBlock("picture", _hoisted_4, [
                _createElementVNode("img", {
                  class: "object-cover absolute transform translate-x--1/2 translate-y--1/2 top-1/2 left-1/2",
                  src: _unref(userData).userphoto,
                  alt: _unref(userData).username
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(userFullname))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(userFullname)), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(userData).usergender)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(userFullname)), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(userData).userbirth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(userData).userbirth), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(userData).useremail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(userData).useremail), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(userData).useremail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(userData).useremail), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})